export const ADD_PASSPORT = 'ADD_PASSPORT';
export const CLEAR_PASSPORTS = 'CLEAR_PASSPORTS';
export const DELETE_PASSPORT = 'DELETE_PASSPORT';
export const SET_CHECKIN_ID = 'SET_CHECKIN_ID';
export const CLEAR_CHECKIN_ID = 'CLEAR_CHECKIN_ID';